<template>
	<b-form-group :label="label">
		<b-form-group :label="showLabels ? 'Date' : ''">
			<b-input-group>
				<b-select v-model="editMonth">
					<option :value="i - 1" v-for="i in 12" :key="i">
						{{i}}
					</option>
				</b-select>

				<b-select v-model="editDay">
					<option :value="i" v-for="i in doesMonthHave31Days(editMonth) ? 31 : 30" :key="i">
						{{i}}
					</option>
				</b-select>
				<b-form-input v-model="editYear"/>
			</b-input-group>
		</b-form-group>
		<b-form-group v-if="showTime" :label="showLabels ? 'Time' : ''">
			<b-input-group>
				<b-select v-model="editHour">
					<option :value="i - 1" v-for="i in 12" :key="i">
						{{i}}
					</option>
				</b-select>
				<b-select v-model="editMinutes">
					<option :value="i - 1" v-for="i in 60" :key="i">
						{{(i - 1).toString().padStart(2, '0')}}
					</option>
				</b-select>
				<b-select v-model="editIsPM">
					<option :value="false">AM</option>
					<option :value="true">PM</option>
				</b-select>
			</b-input-group>
		</b-form-group>
	</b-form-group>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
	props: {
		label : String,
		date : Date,
		showTime: {
			type: Boolean,
			default: false
		},
		showLabels: Boolean
	},
	model: {
		prop: 'date',
		event: 'input'
	},
	data(){
		return {
			timeValues: {
				month: 1,
				day: 1,
				year: 1,
				hour: 1,
				minute: 1,
				isPM: false
			}
		}
	},
	mounted(){
		this.applyDate();
		this.updateDate();
	},
	computed: {
		editMonth: {
			get()
			{
				return this.timeValues.month;
			},
			set(value){
				this.timeValues.month = value;
				if (!this.doesMonthHave31Days(value) && this.editDay == 31)
				{
					this.editDay = 30;
				}
				this.updateDate();
			}
		},
		editDay: {
			get()
			{
				return this.timeValues.day;
			},
			set(value){
				this.timeValues.day = value;
				this.updateDate();
			}
		},
		editYear: {
			get()
			{
				return this.timeValues.year;
			},
			set(value){
				this.timeValues.year = value;
				this.updateDate();
			}
		},
		editHour: {
			get()
			{
				return this.timeValues.hour;
			},
			set(value){
				this.timeValues.hour = value;
				this.updateDate();
			}
		},
		editMinutes: {
			get()
			{
				return this.timeValues.minute;
			},
			set(value){
				this.timeValues.minute = value;
				this.updateDate();
			}
		},
		editIsPM: {
			get(){
				return this.timeValues.isPM;
			},
			set(value){
				this.timeValues.isPM = value;
				this.updateDate();
			}
		}
	},
	methods: {
		doesMonthHave31Days(month)
		{
			return (month <= 6 ? month % 2 == 0 : month % 2 == 1);
		},
		applyDate(){
			let d = this.date;
			this.timeValues.month = d.getMonth();
			this.timeValues.day = d.getDate();
			this.timeValues.year = d.getFullYear();
			this.timeValues.hour = d.getHours() - 1
			if (this.timeValues.hour >= 11)
			{
				this.timeValues.isPM = true;
				this.timeValues.hour = this.timeValues.hour % 12;
			}
			else
			{
				this.timeValues.isPM = false;
			}
			this.timeValues.minute = d.getMinutes();
		},
		updateDate(){
			let d = new Date();
			d.setFullYear(this.timeValues.year);
			d.setMonth(this.timeValues.month);
			d.setDate(this.timeValues.day);
			d.setHours((this.timeValues.hour + 1) % 12 + (this.timeValues.isPM ? 12 : 0), this.timeValues.minute, 0, 0);
			this.$emit('date-changed', d);
			this.$emit('input', d);
			this.$forceUpdate();
		}
	}
})
</script>

<style lang="scss" scoped>

</style>